// extracted by mini-css-extract-plugin
export default {"RoundButton":"RoundButton_RoundButton__9JMKf","transparent":"RoundButton_transparent__6CsP-","copiedMessage":"RoundButton_copiedMessage__g-f7Z"};